/* eslint-disable */
(function ($) {
  $.Redactor.opts.langs.ES = require('transifex/languages/es.json').redactor;
})(jQuery);
